// import consts from "@/consts"
// import {arraySplitIntoChunks} from "@/lib/lib";
import {arrayFilter_OnlyUnique, getApiProps} from "@/lib/lib";
import i18n from "@/i18n";

export default {
    state: {
        notificationsEvents_index: [],
        notificationsEvents: [],
    },
    actions: {
        fetchLastNotificationsEvents({commit, dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                if (args.unitId > 0 && !args.force) {
                    let index = getters.getNotificationsEventsIndex.find(i => (i.unitId == args.unitId && i.date == getters.getDateToday))
                    if (!index) {
                        return resolve(true)
                    }
                }

                dispatch('setLastCall', {name: 'fetchLastNotificationsEvents', args, time: Date.now() / 1000})

                let params = getApiProps('notifications_events', {withAddress: 1, ...args})
                //if(!args.force) params.lastTimes = getters.getNotificationsEventsLastTimeByUnitIds
                delete params.unitId;delete params.last;
                this.$api.notificationsevents.getLast(args.unitId, args.last, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeNotificationsEvents', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchLastNotificationsEvents', args, inprogress: false})
                    });
            })
        },
        fetchNotificationsEvents4Date({commit, dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                args = {unitId: '', date: '', ...args}
                if (args.date == 'today' || !args.date) args.date = getters.getDateToday
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !(args.date > '')) {//!args.unitId ||
                    return reject(false)
                }

                if (args.unitId > 0 && !args.force) {
                    let index = getters.getNotificationsEventsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                    if (index) {
                        return resolve(true)
                    }
                }

                dispatch('setLastCall', {name: 'fetchNotificationsEvents4Date', args, time: Date.now() / 1000})
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastNotificationsEvents', args, time: Date.now() / 1000})
                }

                let params = getApiProps('notifications_events', {withAddress: 1, ...args})
                delete params.unitId;delete params.date;
                this.$api.notificationsevents.get4Date(args.unitId, args.date, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeNotificationsEvents', response.data)
                            if (!params.limit || response.data.length < params.limit) {
                                commit('setNotificationsEventsIndex', {...args, count: response.data.length})
                                if (!args.unitId && response.data.length) {
                                    response.data
                                        .map(e => e.unit_id)
                                        .filter(arrayFilter_OnlyUnique)
                                        .forEach(unitId => {
                                            commit('setNotificationsEventsIndex', {...args, unitId, count: 1})
                                        })
                                }
                            }
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchNotificationsEvents4Date', args, inprogress: false})
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastNotificationsEvents', args, inprogress: false})
                        }
                    });
            })
        },
        fetchNotificationsEvents4Period({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.from || !args.to) {//!args.unitId ||
                    return reject(false)
                }

                // if (args.unitId > 0 && !args.force) {
                //     let index = getters.getNotificationsEventsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                //     if (index) {
                //         return resolve(true)
                //     }
                // }

                dispatch('setLastCall', {name: 'fetchNotificationsEvents4Date', args, time: Date.now() / 1000})
                /* getters.getTimeToday+24h and args.from/to intersect*/
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastNotificationsEvents', args, time: Date.now() / 1000})
                }

                let params = getApiProps('notifications_events', {withAddress: 1, ...args})
                delete params.unitId;delete params.from;delete params.to;
                this.$api.notificationsevents.get4Period(args.unitId, args.from, args.to, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeNotificationsEvents', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchNotificationsEvents4Date', args, inprogress: false})
                        /* getters.getTimeToday+24h and args.from/to intersect*/
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastNotificationsEvents', args, inprogress: false})
                        }
                    });
            })
        },
        reloadNotificationsEvents({commit, dispatch}, args) {
            commit('clearNotificationsEvents')
            return dispatch('fetchNotificationsEvents4Date', {date: 'today', ...args})
        },

        //sayHello() {}
    },
    mutations: {
        setNotificationsEventsIndex(state, params) {
            let i = state.notificationsEvents_index.findIndex(i => i.date == params.date && i.unitId == params.unitId)
            if (i < 0) {
                state.notificationsEvents_index.push(Object.freeze({...params}))
            } else {
                state.notificationsEvents_index[i] = Object.freeze({...state.notificationsEvents_index[i], ...params})
            }
        },
        storeNotificationsEvents(state, nEvents) {
            nEvents = nEvents
                .filter((e, i, _events) => (i === _events.findIndex(_e => _e.xid == e.xid)))
                .filter(e => !state.notificationsEvents.find(se => se.xid == e.xid))
                .map(e => Object.freeze(e))

            // if(nEvents.length) state.notificationsEvents.push(...nEvents)
            if (!nEvents.length) return false
            if (!state.notificationsEvents.length) {
                state.notificationsEvents = nEvents
                return true
            }
            state.notificationsEvents.push(...nEvents)
        },
        clearNotificationsEvents(state, {unitId} = {}) {
            if (unitId) {
                state.notificationsEvents = state.notificationsEvents.filter(e => (e.unit_id || e.object_id) != unitId)
                state.notificationsEvents_index = state.notificationsEvents_index.filter(i => i.unitId != unitId)
            } else {
                state.notificationsEvents = [];
                state.notificationsEvents_index = [];
            }
        },
    },
    getters: {
        getNewNotificationEventsCount(state, getters) {
            let lastVisit = getters.getLastVisitNotifications
            if (getters.getTimeToday > lastVisit) lastVisit = getters.getTimeToday
            return state.notificationsEvents.filter(e => e.time?.utc > lastVisit).length
        },
        getNotificationsEventsIndex(state) {
            return state.notificationsEvents_index
        },
        getNotificationsEvents(state) {
            return state.notificationsEvents
        },
        getNotificationsEventsI18nMessages(state) {
            return state.notificationsEvents
                .map((eventsTextByXid, event) => {
                    let message = event?.message?.msg;
                    if (message) {
                        let matches = message.matchAll(/\$t{([\w]+)}/gi);
                        Array.from(matches).forEach(match => {
                            let str = event?.message[match[1]] || ''
                            let translateKey = 'message.' + 'events' + '.' + str
                            str = i18n.global.te(translateKey) ? i18n.global.t(translateKey) : str
                            message = message.replace(match[0], str);
                        })
                    }
                    return {type: event.type, xid: event.xid, message};
                })
        },
        getNotificationsEventsI18nMessagesByXid(state) {
            return state.notificationsEvents
                .reduce((eventsTextByXid, event) => {
                    let message = event?.message?.msg;
                    if (message) {
                        let matches = message.matchAll(/\$t{([\w]+)}/gi);
                        Array.from(matches).forEach(match => {
                            let str = event?.message[match[1]] || ''
                            let translateKey = 'message.' + 'events' + '.' + str
                            str = i18n.global.te(translateKey) ? i18n.global.t(translateKey) : str
                            message = message.replace(match[0], str);
                        })
                    }
                    eventsTextByXid[event.xid] = message;// || i18n.global.t('message.Unknown')//???
                    return eventsTextByXid;
                }, {})
        },
        getNotificationsEventsLastTimeByUnitIds(state) {
            //.filter(e => e?.time?.utc >= getters.getTimeToday)
            return state.notificationsEvents
                .reduce((timeByUnitIds, event) => {
                    timeByUnitIds[event.unit_id] = event?.time?.utc > timeByUnitIds[event.unit_id] ? event?.time?.utc : timeByUnitIds[event.unit_id]
                    return timeByUnitIds
                }, {})
        },
    }
}
